import { type ReactNode } from 'react';
import { Box } from '@mantine/core';

type Props = {
  children: ReactNode;
};

export const LayoutHeader = ({ children }: Props) => (
  <Box
    sx={theme => ({
      padding: theme.other.spacing(2),
      borderBottom: `1px solid ${theme.colors.gray[1]}`,
      backgroundColor: theme.white,
    })}
  >
    {children}
  </Box>
);
